import { Formik } from 'formik';
import { isEmpty } from 'lodash';
import React from 'react';
import { FormElement, Label } from '@dashboard/components/Form';
import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { TextInput } from '@dashboard/components/Formik';
import FormError, { FormErrorBase } from '@dashboard/components/Formik/components/FormError';
import useUserQueries from '@dashboard/hooks/queries/useUserQueries';
import { transformApiErrorToFormik } from '@dashboard/services/form';

export default function PasswordForm() {
  const { updatePassword } = useUserQueries();

  return (
    <Formik
      initialValues={{
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }}
      onSubmit={async (values, actions) => {
        const { error } = await updatePassword(values);

        if (error) {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        } else {
          actions.resetForm({
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
          });
        }
      }}
    >
      {({ handleSubmit, status, dirty }) => (
        <form onSubmit={handleSubmit}>
          <FormElement>
            <Label htmlFor="currentPassword">Current password</Label>
            <TextInput
              id="currentPassword"
              name="currentPassword"
              type="password"
              placeholder="**********"
              border
              required
            />
            <FormError name="currentPassword" />
          </FormElement>

          <FormElement>
            <Label htmlFor="newPassword">New password</Label>
            <TextInput
              id="newPassword"
              name="newPassword"
              type="password"
              border
              placeholder="New password"
              required
            />
            <FormError name="newPassword" />
          </FormElement>

          <FormElement>
            <Label htmlFor="confirmPassword">Confirm password</Label>
            <TextInput
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              border
              placeholder="Confirm password"
              required
            />
            <FormError name="confirmPassword" />
          </FormElement>

          <FormErrorBase>{status && status}</FormErrorBase>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </form>
      )}
    </Formik>
  );
}
